import { useContext, useEffect, useState } from "react"
import { getPermissions } from "../services/authService";
import { PermissionsContext } from "../contexts/PermissionsContext";


export const usePermissions = () => {

  const { hasPermission } = useContext(PermissionsContext);

  return { hasPermission };

}